{
  "partner": {
    "type": "text",
    "label": "Partner",
    "config": {}
  },
  "redirectUrl": {
    "type": "url",
    "label": "Redirect URL",
    "config": {}
  },
  "returnUrl": {
    "type": "url",
    "label": "Return URL",
    "config": {}
  },
  "metadata": {
    "type": "text",
    "label": "Metadata",
    "config": {}
  },
  "colorMode": {
    "label": "Color Mode",
    "type": "radio",
    "config": {
      "default": "light",
      "options": [
        {
          "label": "Light",
          "value": "light"
        },
        {
          "label": "Dark",
          "value": "dark"
        }
      ]
    }
  },
  "cornerStyle": {
    "type": "radio",
    "label": "Corner style",
    "config": {
      "default": "round",
      "options": [
        {
          "label": "Rounded",
          "value": "round"
        },
        {
          "label": "Square",
          "value": "square"
        },
        {
          "label": "Pill",
          "value": "pill"
        },
        {
          "label": "Custom",
          "value": "custom"
        }
      ]
    }
  },
  "layout": {
    "type": "radio",
    "label": "Layout for the contents",
    "config": {
      "default": "left",
      "options": [
        {
          "label": "Left",
          "value": "left"
        },
        {
          "label": "Centered",
          "value": "center"
        },
        {
          "label": "Inline",
          "value": "inline"
        }
      ]
    }
  },
  "ctaType": {
    "label": "Type of the CTA",
    "type": "radio",
    "min": 0,
    "config": {
      "default": "button",
      "options": [
        {
          "label": "Button",
          "value": "button"
        },
        {
          "label": "Text",
          "value": "text"
        }
      ]
    }
  },
  "borderRadius": {
    "label": "Border Radius",
    "type": "number",
    "min": 0,
    "config": {}
  },
  "borderWidth": {
    "label": "Border Width",
    "type": "number",
    "min": 0,
    "config": {}
  },
  "borderColor": {
    "label": "Border Color",
    "type": "text",
    "config": {}
  },
  "width": {
    "label": "Width",
    "type": "number",
    "min": 0,
    "config": {}
  },
  "height": {
    "label": "Height",
    "type": "number",
    "min": 0,
    "config": {}
  },
  "fontFamily": {
    "label": "Font Family",
    "type": "text",
    "config": {}
  },
  "textColor": {
    "label": "Text Color",
    "type": "text",
    "config": {}
  },
  "backgroundColor": {
    "label": "Background Color",
    "type": "text",
    "config": {}
  },
  "fontSize": {
    "label": "Font Size",
    "type": "number",
    "config": {}
  },
  "isHidden": {
    "label": "Hidden",
    "type": "checkbox",
    "config": {
      "default": false
    }
  }
}
